export default __webpack_public_path__ + "static/hp-brand-deck-15-511fd7a25c421fbe5f0cd2d47938c9d2.png";